// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016-2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import Layout from '@/layout/index.vue'
import type { RouteRecordRaw } from 'vue-router';
import {roterPre} from "@/settings";

const configRouter =
    {
      path: roterPre+`/config`,
      name: 'system_config',
      meta: {
        icon: 'dashboard',
        title: '系统配置'
      },
      alwaysShow: true, // 一直显示根路由
      component: Layout,
      children: [
        {
          path: 'picture',
          name: 'system_config_picture',
          meta: {
            title: '素材管理'
          },
          component: () => import('@/views/system/config/picture.vue')
        },
        {
          path: 'service',
          name: 'Service',
          meta: {
            title: '客服管理'
          },
          component: () => import('@/views/system/service/index.vue')
        },
        {
          path: 'service_staff',
          name: 'ServiceStaff',
          meta: {
            title: '服务人员'
          },
          component: () => import('@/views/system/service_staff/index.vue')
        },
        {
          path: 'service_statistic',
          name: 'ServiceStatistic',
          meta: {
            title: '服务统计'
          },
          component: () => import('@/views/system/service_statistic/index.vue')
        },
        {
          path: 'guarantee',
          name: 'Guarantee',
          meta: {
            title: '保障服务',
            noCache: true
          },
          component: () => import('@/views/system/guarantee/index.vue')
        },

        {
          path: 'freight',
          name: 'Freight',
          meta: {
            title: '物流设置'
          },
          component: () => import('@/views/system/freight/index.vue'),
          children: [
            {
              path: 'shippingTemplates',
              name: 'ShippingTemplates',
              meta: {
                title: '运费模板',
                noCache: true
              },
              component: () => import('@/views/system/freight/shippingTemplates/index.vue')
            },
            {
              path: 'express',
              name: 'Express',
              meta: {
                title: '物流公司',
                noCache: true
              },
              component: () => import('@/views/system/freight/express/index.vue')
            }
          ]
        }

      ]
    }
export default configRouter as RouteRecordRaw